import styled from 'styled-components';

import * as Text from '../../../styles/shared/multibrand-typography';
import * as colors from '../../../styles/shared/colors';
import { breakpoints, respondTo } from '../../../styles/shared/breakpoints';
import { MultiBrandInformationDrawer } from './Drawer/styles';
import PageSection from '../../PageSection';

const isiBodyFontSize = '16px';


export const MultiBrandSafetyPageContainer = styled(PageSection)`
  height: 100%;
  padding-top: 64px;
  > section {
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 0;
    }
    ${Text.H3} {
      margin-bottom: 20px;
      text-transform: uppercase;
      
      ${respondTo.sm`
        margin-bottom: 30px;
      `}
    }
  }

`;

export const MultiBrandHeadingHThree = styled(Text.H4)`
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 8px;
    letter-spacing: -0.24px;
    color: ${colors.ink3};

    @media (max-width: ${breakpoints.mid}px){
        margin-bottom: 10px;
    }
`

export const MultiBrandTwoIndicationSection = styled.section`
    display: flex;
    > div {
        width: 50%;
        padding-right: 40px;
        border-right: 1px solid ${colors.neutralsGrey};

        &:last-child{
          padding-right: 0px;
          padding-left: 40px;
           border-right: none;
        }
    }
    &.expand-container{
        .green-container{
        h6[class^='multibrand-typography__H6']{
          color: ${colors.black};
          margin-bottom: 4px;
          // font-weight: 700;
          }
        ul[class^='multibrand-typography__Ul']{
          li{
            &::before{
              background-color: ${colors.lightGreen};
            }
          }
        }
      }
      .blue-container{
       h6[class^='multibrand-typography__H6']{
          margin-bottom: 4px; 
          &:first-child{
          margin-top:0;
          }     
       }
        ul[class^='multibrand-typography__Ul']{

          li{
            &::before{
              background-color: ${colors.brandBlueLight} !important;
            }
          }
        }
      }
    }
    @media(max-width: ${breakpoints.mid}px){
        flex-direction: column;
        width: 100%;
        > div{
          width: 100%;
          padding: 0;
          border: none;
          &:last-child{
            padding: 0;
            padding-top: 32px;
          }
        }
    }
    .darkColor{
        color: ${colors.black};

        a{
         color: ${colors.brandBlueDark};
        }
      }
`

export const MultiBrandIsiBody = styled.div`
  overflow: auto;
  //  height: 85%;
  margin-bottom: 24px;
  font-size: ${isiBodyFontSize};
  color: #000000;
  line-height: 20px;
  font-weight:400;
  ${respondTo.sm`
    line-height:20px;
    margin-bottom: 32px;
    gap: 32px;
  `}

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  
  p{
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0px;
    }
  }
  
`;
// ${MultiBrandInformationDrawer} & {
//   padding: 20px;
    
//     ${respondTo.sm`
//       padding: 30px;`}
//   }

// Safety List

export const MultiBrandSafetyListContainer = styled.section`
  // height: 100%;
  overflow: hidden;
  @media (max-width:${breakpoints.mid}px){
  height: 100%;
  }
  @media (max-width: 555px){
  
  &.green-container{
  height:90%
  }
  }
  &.green-container{
    h6[class^='multibrand-typography__H6']{
      color: ${colors.black};
      margin-bottom:2px;
      letter-spacing:-0.16px;
      @media (max-width: ${breakpoints.mid}px){
        margin-bottom: 2px;        
      }
      }
    ul[class^='multibrand-typography__Ul']{
      li{
        &::before{
          background-color: ${colors.lightGreen} !important;
        }
      }
    }
  }
  &.blue-container{
    h6[class^='multibrand-typography__H6']{
        @media (max-width: ${breakpoints.mid}px){
        margin-bottom: 2px;
      }
      margin-top: 0px;
    }
    ul[class^='multibrand-typography__Ul']{
      li{
        &::before{
          background-color: ${colors.brandBlueLight};
        }
          ul{
          li{
          &::before{
          height:1px;
        }
          }
          }
      }
    }
  }

  @media (max-width: ${breakpoints.mid}px){
    // height: 90%;
    overflow: auto;
    
    /* Firefox */
    scrollbar-width: none;

    /* IE & old Edge */
    -ms-overflow-style: none;

    /* Chrome, Safari, Edge */
    &::-webkit-scrollbar {
      display: none;
    }

  }
  
`;

//  ${MultiBrandInformationDrawer} & {
//     margin: 0;
//     padding: 20px;

//     ${respondTo.sm`
//       padding: 30px;`}
//   }

export const MultiBrandSafetyItem = styled.div`
  margin-bottom: 20px;

  @media (max-width: ${breakpoints.mid}px){
    margin-bottom: 20px;
  }
`;

export const MultiBrandSafetyItemTitle = styled(Text.H6)`
  font-size: ${isiBodyFontSize};
  margin-bottom: 2px;
  color: ${colors.brandBlueDark};
  font-weight:700;
`;
export const MultiBrandSafetySubItemTitle = styled(Text.H6)`
  font-size: ${isiBodyFontSize};
  margin-bottom: 2px;
  margin-top:16px;
  color: #000000;
  text-decoration: underline;
  font-weight:400;

  // &.green-container{
  //   font-weight:700;
  // }

`;
export const MultiBrandSafetySubItemItalicTitle = styled(Text.H6)`
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 2px;
  color: #000000;
  font-style: italic;
  font-weight:400 !important;
  letter-spacing: -0.16px;
`;

export const MultiBrandSafetyItemList = styled(Text.Ul)`
  li {
    font-size: ${isiBodyFontSize};
    letter-spacing: -0.16px;
    line-height:20px;
    margin: 0 0 16px;
        color: #000000;
        @media (max-width: ${breakpoints.mid}px){
      margin-bottom: 16px;
    }
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

export const MultiBrandSafetyWarningTitle = styled(MultiBrandSafetyItemTitle)`
  color: #000000;
  margin-bottom:2px;
  ${({flat}) => flat && 'margin-bottom: 1px;'}
`;

export const MultiBrandSafetyWarningList = styled(MultiBrandSafetyItemList)`
  li {
    font-size: ${isiBodyFontSize};
    font-weight: 700;
    margin-bottom:0px;
    ${({flat}) => flat && 'margin-bottom: 0px;'}
    @media (max-width: ${breakpoints.mid}px){
      margin-bottom: 0px;
    }
  }
`;

export const MultiBrandFinalWarning = styled(MultiBrandSafetyItemTitle)`
  margin: 0;
  line-height: 20px;
    color: ${colors.ink3};
  a {
    color: ${colors.brandBlueDark};
    text-decoration: underline;
    &.green-highlight{
        color: ${colors.closeGreen};
    }
    &.purple-highlight{
    color: ${colors.lightPurple};
    }
    &:hover {
      text-decoration: none;
    }
  }

`;

export const MultiBrandSafetyJobCode = styled(Text.Footnote)`
  display: block;
  margin-top: 24px;
  text-align: right;
`;